import { menuItemsDef, profileNavItemsDef, settingsItemsDef } from "../navigation/navDefinitions";
import { PLATFORM_CONSOLE_BASE } from "../pages/Platform/XprobaseConsole/platformConsoleRoutes";
import { PARTNER_CONSOLE_BASE } from "../pages/Partner/PartnerConsole/partnerConsoleRoutes";

const ALL_NAV = [...menuItemsDef, ...profileNavItemsDef, ...settingsItemsDef]
  .filter((x) => x.link)
  .sort((a, b) => b.link.length - a.link.length);

const EXCLUDED_PREFIXES = [
  "/login",
  "/signup",
  "/forgot-password",
  "/verify-email",
  "/set-password",
  "/public/",
  "/portal/",
  "/call-popup",
  "/team-popup",
  "/team-tasks-popup",
  "/team-agenda-popup",
  "/team-chat-popup",
];

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function normalizeProductUsagePath(pathOnly) {
  const parts = String(pathOnly || "")
    .split("/")
    .map((seg) => {
      if (!seg) return seg;
      if (/^\d+$/.test(seg)) return ":id";
      if (UUID_RE.test(seg)) return ":id";
      return seg;
    });
  return parts.join("/") || "/";
}

export function shouldExcludeProductUsagePath(pathOnly) {
  const p = String(pathOnly || "");
  if (!p || p === "/") return false;
  return EXCLUDED_PREFIXES.some((prefix) => p === prefix.replace(/\/$/, "") || p.startsWith(prefix));
}

function resolvePlatformScreenKey(pathOnly) {
  if (!pathOnly.startsWith(PLATFORM_CONSOLE_BASE)) return null;
  const rest = pathOnly.slice(PLATFORM_CONSOLE_BASE.length).replace(/^\//, "");
  const section = rest.split("/")[0] || "home";
  return {
    appSurface: "platform",
    screenKey: `platform.${section}`,
    pathNorm: normalizeProductUsagePath(pathOnly),
  };
}

function resolvePartnerScreenKey(pathOnly) {
  if (!pathOnly.startsWith(PARTNER_CONSOLE_BASE)) return null;
  const rest = pathOnly.slice(PARTNER_CONSOLE_BASE.length).replace(/^\//, "");
  const section = rest.split("/")[0] || "overview";
  return {
    appSurface: "partner",
    screenKey: `partner.${section}`,
    pathNorm: normalizeProductUsagePath(pathOnly),
  };
}

function resolveTenantScreenKey(pathOnly) {
  for (const item of ALL_NAV) {
    const link = item.link;
    if (pathOnly === link || pathOnly.startsWith(`${link}/`)) {
      const screenKey = item.res || link.replace(/^\//, "").replace(/\//g, ".") || "home";
      return {
        appSurface: "tenant",
        screenKey,
        pathNorm: normalizeProductUsagePath(pathOnly),
      };
    }
  }
  const seg = pathOnly.split("/").filter(Boolean)[0] || "home";
  return {
    appSurface: "tenant",
    screenKey: seg,
    pathNorm: normalizeProductUsagePath(pathOnly),
  };
}

/**
 * Resolve contexto de analytics para pathname SPA (sem query).
 * @returns {{ appSurface: string, screenKey: string, pathNorm: string } | null}
 */
export function resolveProductUsageContext(fullPath) {
  const pathOnly = String(fullPath || "").split("?")[0] || "/";
  if (shouldExcludeProductUsagePath(pathOnly)) return null;

  return (
    resolvePlatformScreenKey(pathOnly) ||
    resolvePartnerScreenKey(pathOnly) ||
    resolveTenantScreenKey(pathOnly)
  );
}
